import React from 'react'
import Button from '@Components/Buttons/Button'
import RadioSelect from '@Components/Selectors/RadioSelect'
import { SearchResultPartyDetails } from '@Entities/party-details'
import WriterSelectionCard from '@Scenes/SongwriterScene/SongwriterMyWritersScene/SongwriterRequestUpdateSidebar/MergeWriterNamesForm/WriterSelectionCard'

interface SelectPrimaryWriterStepProps {
    writers: SearchResultPartyDetails[]
    primaryWriterIpId: string | null
    setPrimaryWriterIpId(writerIpId: string): void
    onBack(): void
    onNext(): void
}

const SelectPrimaryWriterStep = (props: SelectPrimaryWriterStepProps) => {
    const { writers, primaryWriterIpId, setPrimaryWriterIpId, onBack, onNext } = props

    return (
        <>
            <p>Select which name you want to be the primary: and merge the other name(s) into:</p>
            <div className="writer-selection-list">
                {writers.map((writer) => (
                    <WriterSelectionCard key={writer.ipId} writer={writer}>
                        <RadioSelect
                            id={`primary-writer-${writer.ipId}`}
                            ariaLabel={writer.name}
                            checked={primaryWriterIpId === String(writer.ipId)}
                            onClick={() => setPrimaryWriterIpId(String(writer.ipId))}
                        />
                    </WriterSelectionCard>
                ))}
            </div>
            <div className="footer-buttons">
                <Button mainColor type="secondary" onClick={onBack}>
                    Back
                </Button>
                <Button mainColor type="primary" disabled={!primaryWriterIpId} onClick={onNext}>
                    Next
                </Button>
            </div>
        </>
    )
}
export default SelectPrimaryWriterStep
